import { DatePicker } from "antd";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { ORDER_TYPE_RECEIVE, ORDER_TYPE_RETURN } from "constants/order";
import { useCountOrderByHub } from "hooks";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "reactstrap";
import { Button as AntButton } from "antd";

const HubStatistic = () => {
  const { t } = useTranslation(["orderStatistic"]);
  const initialCountOrderByHubParams = {
    run: false,
    columnFilterKeep: {
      order_type: ORDER_TYPE_RECEIVE.value,
      from_time: `${moment()
        .subtract(1, "weeks")
        .format("YYYY-MM-DD")} 00:00:00`,
      to_time: `${moment().format("YYYY-MM-DD")} 23:59:00`,
      hub_id: "1",
    },
    columnFilter: {},
  };
  const [countOrderByHubParams, setCountOrderByHubParams] = useState(
    initialCountOrderByHubParams
  );
  const [dateFilter, setDateFilter] = useState({
    startDate: moment().subtract(1, "weeks"),
    endDate: moment(),
  });
  const {
    data: dataCountOrderByHub,
    refetch: fetchCountOrderByHub,
    isLoading: isLoadingCountOrderByHub,
  } = useCountOrderByHub({
    key: countOrderByHubParams.order_type,
    enabled: false,
    params: countOrderByHubParams,
  });

  useEffect(() => {
    if (countOrderByHubParams.run) {
      fetchCountOrderByHub();
    }
  }, [countOrderByHubParams]);

  const columnTable = [
    {
      dataField: "hub_name",
      text: t("table.hub_name"),
    },
    {
      dataField: "active_runner_order_amount",
      text: (
        <div className="col-order">{t("table.active_runner_order_amount")}</div>
      ),
    },
    {
      dataField: "active_not_runner_order_amount",
      text: (
        <div className="col-order">
          {t("table.active_not_runner_order_amount")}
        </div>
      ),
    },
    {
      dataField: "completed_order_amount",
      text: (
        <div className="col-order">{t("table.completed_order_amount")}</div>
      ),
    },
    {
      dataField: "total_order_number",
      text: <div className="col-order">{t("table.total_order_number")}</div>,
    },
  ];
  const handleOrderTypeFilter = type => {
    setCountOrderByHubParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        order_type: type.value,
      },
    }));
  };
  const handleDateRangeFilter = value => {
    const startDate = value ? value[0] : undefined;
    const endDate = value ? value[1] : undefined;
    setDateFilter({
      startDate,
      endDate,
    });
    if (startDate && endDate) {
      const filterDate = {
        from_time: startDate
          ? `${startDate.format("YYYY-MM-DD")} 00:00:00`
          : null,
        to_time: endDate ? `${endDate.format("YYYY-MM-DD")} 23:59:00` : null,
      };
      setCountOrderByHubParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          ...filterDate,
        },
      }));
    }
  };

  return (
    <>
      <div className="d-flex flex-row justify-content-start align-items-center gap-2 flex-wrap">
        <DatePicker.RangePicker
          onChange={value => handleDateRangeFilter(value)}
          value={[dateFilter.startDate, dateFilter.endDate]}
          allowClear
        />
        <HubFilter
          isForOrder
          mainFilterParams={countOrderByHubParams}
          setMainFilterParams={setCountOrderByHubParams}
          handleChangeHub={() => {
            setCountOrderByHubParams(prev => ({
              ...prev,
              run: true,
            }));
          }}
          isNotFilterChildHub={true}
          isHaveAllOption={true}
          isFilterAllDefault={true}
          isHidden={true}
        />
        <AntButton
          className="ant-btn-custom"
          type="primary"
          onClick={() => {
            if (
              countOrderByHubParams.columnFilter.order_type ===
              ORDER_TYPE_RECEIVE.value
            ) {
              handleOrderTypeFilter(ORDER_TYPE_RETURN);
            } else {
              handleOrderTypeFilter(ORDER_TYPE_RECEIVE);
            }
          }}
          disabled={isLoadingCountOrderByHub}
        >
          {countOrderByHubParams.columnFilter.order_type ===
          ORDER_TYPE_RECEIVE.value
            ? ORDER_TYPE_RECEIVE.label
            : ORDER_TYPE_RETURN.label}
        </AntButton>
      </div>
      {dateFilter.startDate && dateFilter.endDate ? (
        <RemoteDataTable
          keyField="hub_id"
          data={dataCountOrderByHub || []}
          columns={columnTable}
          isShowRowIndex={false}
          isShowPagination={false}
          isShowSearchAll={false}
          searchSticky={true}
          classNameTable="order-statistic-table"
          loading={isLoadingCountOrderByHub}
        />
      ) : (
        <Alert color="danger" className="mt-4">
          {t("message.alert_date_null")}
        </Alert>
      )}
    </>
  );
};

export default HubStatistic;
